import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Button, Grid,} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {AuthService} from "../../../services/auth-service";
import * as api from '../../../api';


class ClientElement extends Component {

    constructor(props) {
        super(props);
        this.authService = new AuthService();

    }
    onSelectingClient = () => {

            Promise.all([
                api.updateClient(this.props.custKey)
            ])
            .then(([res]) => {

                console.log("Cots Permission - "  + res.cotsAccess)
                  
                
                    localStorage.setItem("cotsAccess", res.cotsAccess);
                    localStorage.setItem("customerId", this.props.custKey);
                    localStorage.setItem("customerName", this.props.name);
                    localStorage.setItem("sector", res.sector);

                    this.props.history.push("/");
                    window.location.reload(); 
            });
    };

    render() {
        return (
            <Grid stackable columns='equal' className="client-element">
                <Grid.Row className="client-row">
                    <Grid.Column>
                        <div className="client-name">{this.props.name}</div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <Button positive onClick={this.onSelectingClient} size='small'>Select</Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default withRouter(ClientElement); 